module.exports = __webpack_public_path__ + "img/rig.130f40e8.png";